import { render, staticRenderFns } from "./doctorAudit.vue?vue&type=template&id=d3c81434&scoped=true"
import script from "./doctorAudit.vue?vue&type=script&lang=js"
export * from "./doctorAudit.vue?vue&type=script&lang=js"
import style0 from "./doctorAudit.vue?vue&type=style&index=0&id=d3c81434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c81434",
  null
  
)

export default component.exports